import {atom} from "recoil";

export const widthR = atom({key:"widthR", default:0})
export const heightR = atom({key:"heightR", default:0})

export const sWidthR = atom({key:"sWidthR", default:0})
export const sHeightR = atom({key:"sHeightR", default:0})

export const portraitModeR = atom({key:"portraitModeR", default:false})
